/**
 * Classe responsável por fornecer os métodos necessários
 * para as colunas do grid de stops.
 * @author: adalto.junior
 * Date: 14/10/13
 * Time: 17:42
 */


Greenmile.GridColumns = Greenmile.GridColumns || {};

Greenmile.GridColumns.Stop = function () {

    this.entity = null;
    this.url = 'form/StopView/index';

    this.setEntity = function (entity) {

        if (entity) {

            this.entity = entity;

        }

    };

    this.setUrl = function (url) {
        if (url) {
            this.url = url;
        }
    };

    this.getFieldsToGridLayout = function (callback) {

        var error  = null,
            ajax   = null,
            random = "?" + new Date().getTime() + Math.floor((Math.random() * 1000) + 1);

        try {

            var browser = Greenmile.Platform.extractBrowserInformations();
            var versionBrowser = Greenmile.Platform.extractBrowserVersion();

            if (browser === "MSIE" && versionBrowser === "9.0") {
                _url += random;
            }

            ajax = new Monet.Ajax();
            ajax.url = this.url;
            ajax.success = function (context) {
                return function (data) {
                    if (data) {
                        if (!App.Forms[context.entity].layout) {
                            App.Forms[context.entity].layout = {};
                        }

                        App.Forms[context.entity].layout.index = data;

                        if (callback) {
                          callback();
                        }
                    }
                };
            }(this);

            ajax.error = function (response) {
                Monet.Configurations.errorNotification(null, response);
            };

            ajax.send();

        } catch (e) {
            error = new Monet.Exception.ReturnError(this,
                'Error on get grid layout on route monitoring stop');
            error.console();
        }

    };

    this.getColumns = function (callback) {

        var error = null;
        try {

          const parseLayoutToColumn = function (layout, entity) {
            const columns = Monet.Grid.getGridLayout(layout.index, entity);
            const columnStatus = {};
            columnStatus.name = '';
            columnStatus.sortable = false;
            columnStatus.resizable = false;
            columnStatus.field = 'stop.status';
            columnStatus.formatter = function (row, cell, value, column, dataContext) {
              return Greenmile.Utils.getStopStatusIcon(dataContext);
            };
            columnStatus.width = 110;

            columns.unshift(columnStatus);

            const createRatingFormatter = function (
              row,
              cell,
              value,
              column,
              dataContext
            ) {
              const rating = new Monet.UI.Fields.Rating();
              const commentListener = 'Greenmile.Rating.Comment(this)';

              rating.setMax(4);
              rating.setValue(value);
              rating.disabled = true;

              return rating.render(commentListener, dataContext).outerHTML;
            };

            const setColumnFormatter = function(column) {
              if (column.field === 'stopSignature.rating') {
                column.formatter = createRatingFormatter;
              }
            };
            columns.forEach(setColumnFormatter);

            if (callback) {
              callback(columns);
            }
          };

            if (this.entity) {

              if (!App.Forms[this.entity].layout) {
                App.Forms[this.entity].layout = {};
              }
              if (!App.Forms[this.entity].layout.index) {
                this.getFieldsToGridLayout(function() {
                  parseLayoutToColumn(App.Forms[this.entity].layout, this.entity);
                }.bind(this));
              } else {
                parseLayoutToColumn(App.Forms[this.entity].layout, this.entity);
              }

            }

        } catch (e) {

            error = new Monet.Exception.ReturnError(this,
                'Error on get  columns to grid stop');
            error.console();
        }

    };

};
